/* Hyperush — the camera peeks out from behind the hero button,
   takes a photo of you, and ducks back.

   It runs on one ambient loop and nothing re-triggers it. An earlier version
   re-fired the animation on hover and on click: that laid a 2.4s one-shot over
   the running 8s loop with !important, then stripped it 2.5s later, so the
   camera cut back mid-flight and looked like it jumped or stopped halfway.
   Do not add a hover or click re-trigger back without solving that. */
(function () {
  'use strict';

  var CAMERA =
    '<svg class="hy-peek__svg" viewBox="0 0 78 62" aria-hidden="true">' +
      '<defs>' +
        '<linearGradient id="hyPeekStripe" x1="0" y1="0" x2="1" y2="0">' +
          '<stop offset="0" stop-color="#3B2E8F"/>' +
          '<stop offset=".34" stop-color="#9A34C4"/>' +
          '<stop offset=".58" stop-color="#E5397B"/>' +
          '<stop offset=".78" stop-color="#F0453A"/>' +
          '<stop offset="1" stop-color="#FDBB2D"/>' +
        '</linearGradient>' +
        '<clipPath id="hyPeekBody">' +
          '<rect x="5" y="18" width="62" height="38" rx="6"/>' +
        '</clipPath>' +
      '</defs>' +
      '<g class="hy-peek__ring">' +
        '<circle cx="66" cy="9" r="6" fill="none" stroke="#9AA0A6" stroke-width="2.6"/>' +
        '<path d="M62 14 58 19" stroke="#9AA0A6" stroke-width="2.6" stroke-linecap="round"/>' +
      '</g>' +
      '<rect x="5" y="18" width="62" height="38" rx="6" fill="#FDBB2D" stroke="#0F1115" stroke-width="2.4"/>' +
      '<g clip-path="url(#hyPeekBody)">' +
        '<rect x="5" y="31" width="62" height="14" fill="url(#hyPeekStripe)"/>' +
      '</g>' +
      '<rect x="5" y="18" width="62" height="38" rx="6" fill="none" stroke="#0F1115" stroke-width="2.4"/>' +
      '<circle cx="31" cy="38" r="11" fill="#0F1115"/>' +
      '<circle cx="31" cy="38" r="6" fill="#2B2350"/>' +
      '<circle cx="28.5" cy="35.5" r="2" fill="#8E86C4" opacity=".8"/>' +
      '<rect class="hy-peek__lamp" x="52" y="23" width="9" height="8" rx="1.6" fill="#0F1115"/>' +
      '<rect x="12" y="23" width="14" height="3.4" rx="1.7" fill="#0F1115" opacity=".55"/>' +
    '</svg>' +
    '<span class="hy-peek__flash" aria-hidden="true"></span>';

  function attach(cta) {
    if (!cta || cta.closest('.hy-peekwrap')) return;

    var wrap = document.createElement('span');
    wrap.className = 'hy-peekwrap';

    var peek = document.createElement('span');
    peek.className = 'hy-peek';
    peek.setAttribute('aria-hidden', 'true');
    peek.innerHTML = CAMERA;

    cta.parentNode.insertBefore(wrap, cta);
    wrap.appendChild(peek);
    wrap.appendChild(cta);

    /* ---- Start the loop only once the page has stopped loading ----------
       The homepage is still pulling reel clips well past the load event.
       Running the first cycles into that contention made the camera stutter.
       The CSS keeps the loop off until .is-ready lands. */
    function go() {
      peek.classList.add('is-ready');
    }
    if (document.readyState === 'complete') {
      schedule();
    } else {
      window.addEventListener('load', schedule, { once: true });
    }
    function schedule() {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(go, { timeout: 4000 });
      } else {
        window.setTimeout(go, 1500);
      }
    }

    /* ---- Don't spend frames when nobody can see it ---------------------- */
    var onScreen = true;
    function sync() {
      peek.classList.toggle('is-paused', document.hidden || !onScreen);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
        sync();
      }, { threshold: 0 }).observe(wrap);
    }
    document.addEventListener('visibilitychange', sync);
  }

  function init() {
    attach(document.querySelector('.hy-hero__cta'));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
